import React, { useState } from "react";
import style from "./Details.module.scss";
import CaretDown24 from "../../../../assets/svg/icons/common/CaretDown24";
import CaretRight24 from "../../../../assets/svg/icons/common/CaretRight24";
import useCommonStore from "../../../../stores/common";
import useMerchantStore from "../../../../stores/merchant";
import { useMediaQuery } from "../../../../hooks/useMediaQuery";

const formatMoney = (value) => {
  const num = Number(value);
  if (!Number.isFinite(num)) return value;
  return num.toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

function Financials() {
  const [isOpen, setIsOpen] = useState(false);
  const expandDetails = useCommonStore((state) => state.expandDetails);
  const activeApp = useMerchantStore((state) => state.activeApp);
  const isMobile = useMediaQuery(768);

  return (
    <div
      className={`${style.accordion_item} ${expandDetails ? style.expanded : ""}`}
    >
      <div
        className={`${style.accordion_head} ${isOpen ? style.open : ""}`}
        onClick={() => setIsOpen(!isOpen)}
      >
        {isMobile ? (
          <CaretRight24 className={`${style.caret_icon} ${isOpen ? style.expended : ""}`} />
        ) : (
          <CaretDown24 />
        )}
        <h5>Financial</h5>
      </div>
      {isOpen && (
        <div className={`${style.accordion_body} ${isMobile && isOpen ? style.expanded : ""}`}>
          <>
            <div className={style.data_item}>
              <p className={style.data_label}>Monthly Cap</p>
              <p className={style.data_value}>
                {activeApp?.merchant_details?.monthly_cap != null && activeApp?.merchant_details?.monthly_cap !== ""
                  ? `$ ${formatMoney(activeApp.merchant_details.monthly_cap)}`
                  : "-"}
              </p>
            </div>

            <div className={style.data_item}>
              <p className={style.data_label}>Monthly Keyed Cap</p>
              <p className={style.data_value}>
                {activeApp?.merchant_details?.monthly_keyed_cap != null && activeApp?.merchant_details?.monthly_keyed_cap !== ""
                  ? `$ ${formatMoney(activeApp.merchant_details.monthly_keyed_cap)}`
                  : "-"}
              </p>
            </div>

            <div className={style.data_item}>
              <p className={style.data_label}>On Hold</p>
              <p className={style.data_value}>
                {activeApp?.merchant_details?.on_hold != null && activeApp?.merchant_details?.on_hold !== ""
                  ? activeApp.merchant_details.on_hold
                  : "-"}
              </p>
            </div>

            <div className={style.data_item}>
              <p className={style.data_label}>OH Balance</p>
              <p className={style.data_value}>
                {activeApp?.merchant_details?.oh_balance != null && activeApp?.merchant_details?.oh_balance !== ""
                  ? `$ ${formatMoney(activeApp.merchant_details.oh_balance)}`
                  : "-"}
              </p>
            </div>

            <div className={style.data_item}>
              <p className={style.data_label}>Reserve %</p>
              <p className={style.data_value}>
                {activeApp?.merchant_details?.reserve != null && activeApp?.merchant_details?.reserve !== ""
                  ? `${activeApp.merchant_details.reserve}%`
                  : "-"}
              </p>
            </div>

            <div className={style.data_item}>
              <p className={style.data_label}>Reserve Bal</p>
              <p className={style.data_value}>
                {activeApp?.merchant_details?.reserve_balance != null && activeApp?.merchant_details?.reserve_balance !== ""
                  ? `$ ${formatMoney(activeApp.merchant_details.reserve_balance)}`
                  : "-"}
              </p>
            </div>

            <div className={style.data_item}>
              <p className={style.data_label}>MTD Net Sales</p>
              <p className={style.data_value}>
                {activeApp?.merchant_details?.month_to_date_sales != null && activeApp?.merchant_details?.month_to_date_sales !== ""
                  ? `$ ${formatMoney(activeApp.merchant_details.month_to_date_sales)}`
                  : "-"}
              </p>
            </div>

            <div className={style.data_item}>
              <p className={style.data_label}>TIN Status</p>
              <p className={style.data_value}>
                {activeApp?.merchant_details?.tin_status != null && activeApp?.merchant_details?.tin_status !== ""
                  ? activeApp.merchant_details.tin_status
                  : "-"}
              </p>
            </div>

            <div className={style.data_item}>
              <p className={style.data_label}>PCI Status</p>
              <p className={style.data_value}>
                {activeApp?.merchant_details?.pci_status != null && activeApp?.merchant_details?.pci_status !== ""
                  ? activeApp.merchant_details.pci_status
                  : "-"}
              </p>
            </div>
          </>
        </div>
      )}
    </div>
  );
}

export default Financials;
